import React from 'react';

const AffiliateSection = () => {
  return (
    <section id="affiliate" className="section">
      <div className="container text-center">
        <h2 className="section-title">Únete a Nuestro Equipo</h2>
        <p className="lead">Conviértete en parte de la familia LactiGo y aprovecha la oportunidad de crecer con nosotros.</p>
        <div className="row mt-5">
          <div className="col-md-6 mb-3">
            <a href="https://me.lactigo.com/account/register/dannyvargasinternacional" target="_blank" rel="noopener noreferrer" className="btn btn-primary btn-lg w-100">Afiliarse como Asociado</a>
          </div>
          <div className="col-md-6 mb-3">
            <a href="https://www.lactigo.com/collections/founders-pack?refID=16070" target="_blank" rel="noopener noreferrer" className="btn btn-primary btn-lg w-100">Afiliarse como Fundador</a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AffiliateSection;